import React, { useEffect, useState } from "react";
import './AdminDashboardPage.css';
import Can from '../../permissions/Can.js';
import AdminNavbar from "../../ui/AdminNavbar/AdminNavbar";
import { useDispatch, useSelector } from "react-redux";
import {
  getUsersAsync,
  getOfficesAsync,
  getDevicesAsync,
  getUsers,
  getOffices,
  getDevices,
  getHomeAssistantsAsync,
  getHomeAssistants,
} from "../../../features/redux/adminSlice";
import UserPage from "../UserPage/UserPage";
import OfficePage from "../OfficePage/OfficePage";
import DoorPage from "../DoorPage/DoorPage";
import { getSession } from "../../../features/redux/sessionSlice.js";
import HomeAssistantPage from "../HomeAssistantPage/HomeAssistantPage.js";

function AdminDashboardPage() {
  const dispatch = useDispatch();
  const users = useSelector(getUsers);
  const offices = useSelector(getOffices);
  const devices = useSelector(getDevices);
  const homeAssistants = useSelector(getHomeAssistants);
  const currentSession = useSelector(getSession);
  const [activeTab, setActiveTab] = useState('users');

  useEffect(() => {
    dispatch(getUsersAsync());
    dispatch(getOfficesAsync());
    dispatch(getDevicesAsync());
    dispatch(getHomeAssistantsAsync());
  }, [dispatch]);

  return (
    currentSession.admin && <div className="admin-dashboard-wrapper">
      <AdminNavbar activeTab={activeTab} setActiveTab={setActiveTab} />

      {activeTab === 'users' && <UserPage users={users} offices={offices} />} {/* Pass offices prop */}
      {activeTab === 'offices' && <OfficePage offices={offices} />}
      {activeTab === 'doors' && <DoorPage devices={devices} offices={offices}/>}
      {activeTab === 'homeAssistants' && <HomeAssistantPage homeAssistants={homeAssistants}  offices={offices}/>}

    </div>
  );
}

export default AdminDashboardPage;
